<template>
  <div class="column selection-list">
    <SelectionListHeader
      :title="title"
      :tab="tab"
      :mode="mode"
      :useDropdownInsteadOfSearch="useDropdownInsteadOfSearch"
      :dropdownTitle="dropdownTitle"
      :dropdownOptions="dropdownOptions"
      :dropdownPlaceholder="dropdownPlaceholder"
      :searchValueProp="searchValue"
      @search="search"
      @searchDropdown="searchDropdown"
      @changeDropdownSelection="changeDropdownSelection"
    />
    <div class="list-container">
      <div
        class="panel-list narrow no-hover"
        v-for="(item, index) in listItems"
        :key="item[idName]"
      >
        <p class="panel-list-item">
          {{ item.buildingName && !isAddMode && item.buildingName != (item.displayName || item[displayName])
              ? `${item.buildingName} - `
              : `` }}
          {{ item.displayName || item[displayName] }}
        </p>

        <div v-if="selectionOptions?.length > 0 && !isAddMode">
          <div class="control item-dropdown">
            <v-select
              class="panel-select header"
              v-model="item.objectOption"
              :options="selectionOptions"
              :allowEmpty="false"
              :internalSearch="false"
              :showLabels="false"
              :searchable="false"
              @select="(event) => selectedItemOption(item, event)"
              track-by="value"
              label="name"
            >
              <span slot="noResult">{{ $t('selection_list.no_results') }}</span>
              <span
                slot="caret"
                slot-scope="{ toggle }"
                class="caret"
                @mousedown.prevent.stop="toggle()"
              ><i class="fas fa-caret-down caret-inner" /></span>
            </v-select>
          </div>
        </div>
        <span class="icon" @click="selectItem(item, index)">
          <i class="fas" :class="isAddMode ? 'fa-plus' : 'fa-minus'" />
        </span>
      </div>
      <div class="panel-list narrow no-hover" v-if="listItems.length == 0">
        <p class="header-item">
          {{ isAddMode || searchValue ? $t('selection_list.no_results') : blankSelection }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SelectionListHeader from './SelectionListHeader';
import iconMixin from '@/mixins/iconMixin.js';

export default {
  mixins: [iconMixin],
  components: { SelectionListHeader },
  props: {
    listItems: Array,
    title: String,
    tab: Number,
    mode: String,
    blankSelection: String,
    useDropdownInsteadOfSearch: Boolean,
    dropdownTitle: String,
    dropdownOptions: Array,
    dropdownPlaceholder: String,
    selectionOptions: Array,
    idName: { type: String, default: 'id' },
    displayName: { type: String, default: 'name' },
    searchValueProp: String,
  },
  data() {
    return { searchValue: '' };
  },
  watch: {
    listItems: {
      handler() {
        if (this.selectionOptions) {
          this.listItems.map(item => {
            if (!item.objectOption) {
              item.objectOption = this.selectionOptions.find(
                option => option.value == item.moveType
              );
              return item;
            }
          });
        }
        this.attachDisplayNames();
      },
      immediate: true
    }
  },
  computed: {

    isAddMode() {
      return this.mode === 'add';
    }
  },
  methods: {
    attachDisplayNames() {
      (this.listItems || []).forEach(item => {
        if (
          item &&
          (item.inventoryType ||
            item.flawCategoryId ||
            item.category ||
            item.key)
        ) {
          item.displayName = this.displayFPName(item);
        }
      });
    },

    selectItem(item, index) {
      this.$emit('selectItem', item, index);
    },
    search(value) {
      this.searchValue = value;
      this.$emit('search', value);
    },
    changeDropdownSelection(item) {
      this.$emit('changeDropdownSelection', item);
    },
    selectedItemOption(item, option) {
      this.$emit('selectedItemOption', item, option.value);
      this.$forceUpdate(); 
    },
    searchDropdown(value) {
      this.$emit('searchDropdown', value);
    }
  },
  created() {
    if (this.selectionOptions) {
      this.listItems.map(item => {
        if (!item.objectOption) {
          item.objectOption = this.selectionOptions.find(
            option => option.value == item.moveType
          );
          return item;
        }
      });
    }
    this.attachDisplayNames();

    this.searchValue = this.searchValueProp;
  }
};
</script>

<style lang="scss" scoped>
.item-dropdown {
  margin-right: 1rem;
  margin-left: 1rem;
}

.selection-list {
  display: flex;
  flex-direction: column;
  min-height: 200px;

  :first-child {
    flex: 5;
  }

  .list-container {
    overflow: auto;
    height: 100%;
  }
  padding-bottom: 2rem;
}
</style>

<style lang="scss">
.item-dropdown .multiselect.panel-select {
  min-height: 30px;
  min-width: 100px;

  .multiselect__tags {
    min-height: 30px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .caret {
    padding: 8px 7px 6px 6px;
    padding-top: 2px;
    padding-bottom: 2px;
  }
}
</style>
